import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';

// GSAP
import { gsap } from "gsap";
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { horizontalLoop } from './gsapHorizontalLoop';
import Lenis from 'lenis';

// Swiper
import Swiper from 'swiper';
import { Autoplay, EffectCreative, EffectFade, Pagination, Navigation } from 'swiper/modules';

// Three.js
import { threeModule } from './three.js';

// Components
threeModule();

// GSAP
window.gsap = gsap;
window.ScrollTrigger = ScrollTrigger;
window.gsapHorizontalLoop = horizontalLoop;

// Swiper
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/effect-creative';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

window.Swiper = Swiper;
Swiper.use([Autoplay, EffectCreative, EffectFade, Pagination, Navigation]);

// Global
window.Alpine = Alpine;

// Inits
Alpine.plugin(collapse);
Alpine.start();

// Initialize Lenis
const lenis = new Lenis({
    autoRaf: true,
    duration: 1.5,
    anchors: true,
    prevent: (node) => node.classList?.contains('js-modal')
});

lenis.on('scroll', (event) => {
    ScrollTrigger.update();
});